export default __webpack_public_path__ + "static/media/online-community.1ac5ba23.svg";